export default __webpack_public_path__ + "static/media/SiteConstructor.0b110274.png";